import { jsx as _jsx } from "react/jsx-runtime";
import Collapsible from "react-collapsible";
const CollapsibleNative = ({ ...props }) => {
    return _jsx(Collapsible, { ...props });
};
export default CollapsibleNative;
